import React from "react";
import PropTypes from "prop-types";

/**
 * ProductPrice Atom - Displays formatted product price with currency
 * @component
 * @example
 * <ProductPrice price={99.99} currency="€" formatPrice={(p) => p.toFixed(2)} />
 */
const ProductPrice = ({
    price,
    currency = "€",
    formatPrice,
    className = "",
    isSpecial = false,
}) => {
    const displayPrice = formatPrice ? formatPrice(price) : price;

    return (
        <div className={`text-md font-bold font-sans ${isSpecial ? "text-white" : "text-red-300"} ${className}`}>
            <span>{displayPrice} </span>
            {currency}
        </div>
    );
};

ProductPrice.propTypes = {
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    currency: PropTypes.string,
    formatPrice: PropTypes.func,
    className: PropTypes.string,
    isSpecial: PropTypes.bool,
};

export default ProductPrice;
